import React from 'react';
import { PapiGallection } from '@wix/da-types-papi';
import { useFlag } from '@wix/da-react-context/pkg/flags/hooks';
import ConditionalWrapper from '@wix/da-shared-react/pkg/ConditionalWrapper';
import ErrorBoundary from '@wix/da-shared-react/pkg/ErrorBoundary';
import { IconSize } from '@wix/da-ds/pkg/Icons/IconWrap';
import FolderContent from '../FolderContent';
import FolderBarFolderDropdown from '../FolderBar/_partials/FolderBarFolderDropdown';
import WidgetHeaderMobile from '../../../UserWidgets/_partials/WidgetHeaderMobile';
import SearchField from '../SearchField';

import profilesCssVars from '../../../../styles/variables.scss';
import s from './GallectionSimpleView.scss';

export interface Props {
  currentFolder: PapiGallection;
}

const MobileGallectionSimpleView: React.FC<Props> = ({ currentFolder }) => {
  const isSearchFieldEnabled = useFlag('gallery_search_mobile');
  return (
    <div className={s['root']}>
      <ErrorBoundary>
        <WidgetHeaderMobile
          isSticky={false}
          rootClassName={s['widget-header-mobile']}
          header={false}
          extras={
            <ConditionalWrapper
              condition={isSearchFieldEnabled}
              wrap={child => (
                <div className={s['header-extras']}>
                  <SearchField className={s['search-field']} />
                  {child}
                </div>
              )}
            >
              <FolderBarFolderDropdown
                offsetTop={
                  parseInt(profilesCssVars['mobile-navbar-height']) - 1
                }
                currentFolder={currentFolder}
                arrowIconSize={IconSize.MEDIUM}
              />
            </ConditionalWrapper>
          }
        />
        <div id="sub-folder-gallery">
          <FolderContent
            key={currentFolder.folderId}
            folderId={currentFolder.folderId}
          />
        </div>
      </ErrorBoundary>
    </div>
  );
};
MobileGallectionSimpleView.displayName = 'MobileGallectionSimpleView';

export default MobileGallectionSimpleView;
